import { Link } from 'react-router-dom';

const featuredArticles = [
  {
    slug: '/article/basetao-review-2026',
    title: 'Basetao Review 2026: Is It Worth Your Money?',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20product%20review%20concept%20with%20five%20star%20rating%20display%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20photography%2C%20gentle%20shadows&width=600&height=400&seq=feat-review-v2&orientation=landscape',
    desc: 'In-depth analysis of Basetao fees, shipping, warehouse service, and real user experiences.',
  },
  {
    slug: '/article/basetao-shipping-cost-guide',
    title: 'Basetao Shipping Cost Guide 2026',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20shipping%20and%20logistics%20concept%20with%20cardboard%20boxes%20on%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20photography&width=600&height=400&seq=feat-shipping-v2&orientation=landscape',
    desc: 'Real prices, shipping line comparisons, weight calculations, and money-saving tips.',
  },
  {
    slug: '/article/basetao-coupon-codes',
    title: 'Basetao Coupon Codes & Discounts 2026',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20discount%20coupon%20concept%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20product%20photography%2C%20gentle%20shadows&width=600&height=400&seq=feat-coupon-v2&orientation=landscape',
    desc: 'Latest verified promo codes, seasonal discounts, and saving strategies.',
  },
  {
    slug: '/article/basetao-warehouse-guide',
    title: 'Basetao Warehouse Complete Guide',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20organized%20warehouse%20storage%20concept%20with%20packages%20on%20warm%20wooden%20shelves%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20photography&width=600&height=400&seq=feat-warehouse-v2&orientation=landscape',
    desc: 'Storage, QC photos, consolidation, and warehouse management explained.',
  },
  {
    slug: '/article/is-basetao-legit',
    title: 'Is Basetao Legit? Safety Review',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20trust%20and%20security%20concept%20with%20shield%20symbol%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20photography&width=600&height=400&seq=feat-legit-v2&orientation=landscape',
    desc: 'Honest safety check covering payment security, buyer protection, and scam analysis.',
  },
  {
    slug: '/article/basetao-spreadsheet-template',
    title: 'Basetao Spreadsheet Template Guide',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20spreadsheet%20display%20on%20laptop%20screen%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20productivity%20photography&width=600&height=400&seq=feat-template-v2&orientation=landscape',
    desc: 'Free download, setup instructions, customization tips, and best practices.',
  },
  {
    slug: '/article/basetao-spreadsheet-finds',
    title: 'Best Basetao Spreadsheet Finds 2026',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20curated%20fashion%20product%20collection%20on%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20lifestyle%20photography&width=600&height=400&seq=feat-finds-v2&orientation=landscape',
    desc: 'Trending products, hidden gems, and community-vetted discoveries.',
  },
  {
    slug: '/article/basetao-vs-alternatives',
    title: 'Basetao vs Superbuy vs Sugargoo vs CSSBuy',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20comparison%20concept%20with%20four%20distinct%20packages%20on%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20photography&width=600&height=400&seq=feat-compare-v2&orientation=landscape',
    desc: 'Comprehensive comparison of fees, shipping, and service quality across all agents.',
  },
  {
    slug: '/article/basetao-shopping-guide',
    title: 'Basetao Shopping Guide for Beginners',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20shopping%20guide%20concept%20with%20open%20book%20on%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20lifestyle%20photography&width=600&height=400&seq=feat-guide-v2&orientation=landscape',
    desc: 'Complete beginner tutorial — account setup, product discovery, ordering, and delivery.',
  },
];

const remainingKeywords = [
  { label: 'Basetao Spreadsheet Link', slug: '/article/basetao-spreadsheet-guide' },
  { label: 'Basetao Alternatives', slug: '/article/basetao-vs-alternatives' },
  { label: 'Basetao Shipping Lines', slug: '/article/basetao-shipping-cost-guide' },
  { label: 'Basetao QC Photos', slug: '/article/basetao-warehouse-guide' },
  { label: 'Basetao Discount Code', slug: '/article/basetao-coupon-codes' },
  { label: 'Basetao Guide 2026', slug: '/article/basetao-shopping-guide' },
];

export default function SEOContent() {
  return (
    <>
      {/* What Is Basetao Spreadsheet */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
              What Is Basetao Spreadsheet?
            </h2>
            <div className="w-16 h-0.5 bg-primary-400/60 mx-auto mb-6"></div>
          </div>

          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed">
            <p className="text-sm md:text-base mb-4">
              <strong className="text-foreground-900">Basetao Spreadsheet</strong> is a powerful resource system designed to help shoppers organize products, compare prices, track orders, and improve their purchasing workflow. Whether you are a first-time buyer or an experienced shopper, having a well-structured Basetao Spreadsheet can transform the way you discover and manage your purchases.
            </p>
            <p className="text-sm md:text-base mb-4">
              With the right <strong className="text-foreground-900">Basetao Spreadsheet template</strong>, users can save product links, compare sellers across multiple platforms, track warehouse status in real-time, estimate shipping costs before placing orders, and manage comprehensive shopping lists. The community behind Basetao Spreadsheet continuously shares verified finds, spreadsheet links, and templates that make the entire process seamless.
            </p>
            <p className="text-sm md:text-base">
              Thousands of users rely on <strong className="text-foreground-900">Basetao Spreadsheet finds</strong> to discover trending products, exclusive deals, and hidden gems across categories like Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more. By leveraging these community-driven resources, shoppers save both time and money while making informed decisions.
            </p>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              Read the Complete Basetao Spreadsheet Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Users Love Basetao Spreadsheet */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              Why Thousands Use Basetao Spreadsheet
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              From product discovery to delivery tracking, Basetao Spreadsheet streamlines every step
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {[
              {
                icon: 'ri-database-2-line',
                title: 'Product Database',
                desc: 'Save and organize product links, images, and pricing information in one structured spreadsheet.',
              },
              {
                icon: 'ri-map-pin-line',
                title: 'Shopping Tracker',
                desc: 'Monitor every product from initial discovery through warehouse arrival and final delivery.',
              },
              {
                icon: 'ri-ship-line',
                title: 'Shipping Planner',
                desc: 'Estimate shipping costs across different lines before placing your order to optimize budgets.',
              },
              {
                icon: 'ri-star-line',
                title: 'Review Database',
                desc: 'Access real user experiences, ratings, and detailed feedback on products and sellers.',
              },
            ].map((feature) => (
              <div
                key={feature.title}
                className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-lg md:text-xl text-secondary-600`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured SEO Articles Section */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              In-Depth Basetao Guides & Resources
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Explore our comprehensive collection of Basetao articles covering everything you need to know
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredArticles.map((article) => (
              <Link
                key={article.slug}
                to={article.slug}
                className="group bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all duration-300"
              >
                <div className="w-full h-40 md:h-44 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Read Article
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              Basetao Spreadsheet vs Traditional Shopping
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              See how a structured spreadsheet transforms your shopping experience
            </p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="border-b-2 border-background-300/60">
                  <th className="text-left py-3 px-4 font-semibold text-foreground-900">Feature</th>
                  <th className="text-center py-3 px-4 font-semibold text-foreground-600">Without Spreadsheet</th>
                  <th className="text-center py-3 px-4 font-semibold text-primary-600">With Basetao Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Product Tracking', without: 'Hard to manage', with: 'Effortlessly organized' },
                  { feature: 'Price Comparison', without: 'Manual and slow', with: 'Side-by-side in seconds' },
                  { feature: 'Order Management', without: 'Confusing and scattered', with: 'Centralized and clear' },
                  { feature: 'Budget Control', without: 'Limited visibility', with: 'Complete transparency' },
                  { feature: 'Shipping Estimates', without: 'Guesswork only', with: 'Data-driven calculations' },
                ].map((row, i) => (
                  <tr key={row.feature} className={`border-b border-background-200/50 ${i % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                    <td className="py-3 px-4 font-medium text-foreground-900">{row.feature}</td>
                    <td className="py-3 px-4 text-center text-foreground-500">{row.without}</td>
                    <td className="py-3 px-4 text-center text-primary-600 font-medium">{row.with}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* More Keywords */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              More Basetao Resources
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Quick access to additional Basetao guides and information
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
            {remainingKeywords.map((kw) => (
              <Link
                key={kw.label}
                to={kw.slug}
                className="bg-background-100 rounded-lg border border-background-200/60 p-3 md:p-4 text-center hover:border-accent-200/60 transition-all duration-300 group"
              >
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-accent-600 transition-colors">
                  {kw.label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lifestyle%20scene%20with%20shopping%20bags%20and%20fashion%20accessories%20on%20warm%20wooden%20surface%2C%20soft%20natural%20light%20from%20window%2C%20cream%20and%20terracotta%20warm%20tones%2C%20editorial%20photography%2C%20gentle%20shadows%2C%20aspirational%20yet%20approachable%20aesthetic&width=1800&height=600&seq=cta-bg-v2&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/30"></div>
        </div>

        <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4">
            Ready to Improve Your Basetao Shopping Workflow?
          </h2>
          <p className="text-white/75 text-sm md:text-base mb-8">
            Join thousands of savvy shoppers using Basetao Spreadsheet to discover, organize, and save on every purchase.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition-all text-sm whitespace-nowrap"
            >
              Visit Main Platform
            </a>
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/90 text-foreground-900 font-semibold rounded-md hover:bg-white transition-all text-sm whitespace-nowrap"
            >
              Read Full Guide
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}